import * as React from "react";
import { DocumentFragment } from "../../graphql/fragments";
import useTranslations from "../../hooks/useTranslations";
import { AttachmentIcon, DotVerticalIcon } from "../icons";
import { Menu, MenuItem, MenuList, MenuButton } from "../wombat-ui";

type DocumentPlateProps = {
  deleteDocument: (any) => {};
  deleteLoading: boolean;
  allowDelete: boolean;
  document: DocumentFragment;
};

export const DocumentPlate: React.FC<DocumentPlateProps> = ({
  document,
  deleteDocument,
  allowDelete = true,
}) => {
  const t = useTranslations();

  return (
    <li
      key={document.id}
      className="flex items-center justify-between py-3 text-sm"
    >
      <div className="flex items-center flex-1 w-0">
        <AttachmentIcon iconClassName="flex-shrink-0 w-5 h-5 text-gray-400" />
        <span className="flex-1 w-0 ml-2 truncate">{document.filename}</span>
      </div>
      <div className="flex items-center flex-shrink-0 ml-4">
        <a
          download={document.filename}
          target="_blank"
          href={document.url}
          id={`downloadDocumentLink-${document.id}`}
          className="mr-3 font-medium text-primary-500 hover:text-primary-400"
        >
          {t("mads.downloadDocument")}
        </a>
        <Menu key="remove_document">
          <MenuButton
            id={`documentMenu-${document.id}`}
            icon={DotVerticalIcon}
            scale="inline"
            variant="ghost"
          />
          <MenuList>
            <MenuItem
              disabled={!allowDelete}
              onSelect={() =>
                deleteDocument({
                  variables: { input: { id: document.id } },
                })
              }
              data-test-id={`deleteDocumentButton-${document.id}`}
            >
              {t("forms.actions.delete")}
            </MenuItem>
          </MenuList>
        </Menu>  
      </div>
    </li>
  );
};
